const PREFIX = "PROFILE";

export class GET_PROFILE_DETAILS {
  public static readonly type = `[${PREFIX}] GET PROFILE DETAILS`;
  constructor(public readonly payload: string) {}
}
export class GET_ELEARNING_LOV {
  public static readonly type = `[${PREFIX}] GET ELEARNING LOV`;
  constructor(public readonly payload: string) {}
}
export class GET_CPD_STATUS {
  public static readonly type = `[${PREFIX}] GET CPD STATUS`;
  constructor(public readonly payload: string) {}
}

export class SEARCH_ELEARNING {
  public static readonly type = `[${PREFIX}] SEARCH ELEARNING`;
  constructor(public readonly payload) {}
}
export class RESET_SEARCH_ELEARNING_DATA {
  public static readonly type = `[${PREFIX}] RESET E-LEARNING`;
}
export class CHANGE_PASSWORD {
  public static readonly type = `[${PREFIX}] POST CHANGE PASSWORD`;
  constructor(public readonly payload: any) {}
}
export class PROFILE_UPDATE_CONTACT_DETAILS {
  public static readonly type = `[${PREFIX}] PROFILE UPDATE CONTACT DETAILS`;
  constructor(public readonly payload) {}
}
export class PROFILE_CHANGE_SECRET_ANSWER {
  public static readonly type = `[${PREFIX}] PROFILE CHANGE SECRET ANSWER`;
  constructor(public readonly payload) {}
}
export class RESET_PROFILE_STATE_RESPONSE {
  public static readonly type = `[${PREFIX}] RESET PROFILE STATE RESPONSE`;
}

export class GET_FILTERED_AGENT_LIST {
  public static readonly type = `[${PREFIX}] GET FILTERED AGENT LIST`;
  constructor(public readonly payload: any) {}
}
